import React, { useState, useEffect, useRef } from 'react';
import { Box, TextField, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SearchField = ({ 
  onSearch,
  placeholder = "Search",
  size = "small",
  initialValue = "",
  debounceDelay = 300,
}) => {
  const [searchTerm, setSearchTerm] = useState(initialValue);
  const debounceRef = useRef(null);
  const onSearchRef = useRef(onSearch);

  // Always keep latest onSearch reference
  useEffect(() => {
    onSearchRef.current = onSearch;
  }, [onSearch]);

  // Sync with initial value if parent changes it
  useEffect(() => {
    setSearchTerm(initialValue);
  }, [initialValue]);

  // ✅ Debounced search effect
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      // Use ref to avoid re-triggering on parent re-render
      onSearchRef.current(searchTerm.trim());
    }, debounceDelay);

    return () => clearTimeout(debounceRef.current);
  }, [searchTerm, debounceDelay]);

  const handleChange = (e) => setSearchTerm(e.target.value);

  const handleClear = () => {
    setSearchTerm('');
    onSearchRef.current(''); // instantly clear
  };

  return (
    <Box display="flex" alignItems="center">
      <TextField
        variant="outlined"
        size={size}
        value={searchTerm}
        placeholder={placeholder}
        onChange={handleChange}
      />
      {searchTerm && (
        <IconButton
          size={size}
          onClick={handleClear}
          sx={{ ml: 1 }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default SearchField;